import { AuthType, Profile } from '@/iam/external/types';
import { Credentials } from '@/iam/external';
import api from '../API';

export interface NewProfile {
  externalId: string,
  typeId: number,
  accountId: number,
  description: string,
  authType: AuthType,
  credentials: Credentials,
  permissions: string[]
}

export function add(profile: NewProfile): Promise<Profile> {
  return api
    .post(`accounts/${profile.accountId}/profiles`, profile)
    .then(response => response.data);
}
